import { getLimits } from '../services';
export const fetchLimits = () => getLimits().then(response => {
    if (!response?.data)
        throw new Error('An unknown error ocurred');
    return formatResponse(response?.data);
});
const formatResponse = (response) => response?.data?.map((limit) => ({
    title: limit.title,
    value: {
        hired: limit.value[0],
        used: limit.value[1],
    },
    type: limit.type,
    tooltip: limit.tooltip,
}));
